<template>
  <div class="block-container">
    <FriedIcon class="icon" :icon="icon" />
    <FriedParagraph class="text">{{ text }}</FriedParagraph>
  </div>
</template>

<script lang="ts" setup>
import type { IconName } from '@getaccept/fried-tofu';

defineProps<{ text: string; icon: IconName }>();
</script>

<style scoped>
.block-container {
  padding: var(--spacing-50) 0;
  display: flex;
  align-items: center;

  .icon {
    margin-right: var(--spacing-50);
  }
}
</style>
